import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, openCrudRowsEditorDialogInAttributeEditorMode, REPOSITORY_FILE_ROWS_TYPE, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_MAINTENANCE_TYPE, AssetMaintenance } from 'assets-model';
import { AssetMaintenanceDocumentPermission, AssetMaintenanceDocumentService } from 'assets-service';
import { AssetMaintenanceDocumentEditDialogComponent, AssetMaintenanceDocumentEditDialogConfig, AssetMaintenanceDocumentRowsComponent } from './asset-maintenance-document-rows.component';
import { AssetMaintenanceRowsComponentMode } from './asset-maintenance-rows.component';


@Component({
  selector: 'app-asset-maintenance-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AssetMaintenanceEditorComponent extends CrudEditComponent<AssetMaintenance, number> implements OnInit {

  private assetMntDocumentPermission: AssetMaintenanceDocumentPermission[];

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage,
    protected assetMntDocumentService: AssetMaintenanceDocumentService) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    if (this.createMode) {
      this.editorTitle = "Create " + this.composedAssetClassParameter + " Maintenance";
    }
    const self = this;
    this.actions = [];
    if (!this.createMode) {
      if (!this.readOnly) {
        this.actions.push(<Action>{
          title: 'Attach Documents',
          get enabled(): boolean {
            return self.isAssetMntDocumentsEnabled();
          },
          color: true,
          get available(): boolean {
            return self.isAssetMntDocumentsAvailable();
          },
          doAction() {
            self.openAssetMntDocumentDialog();
          }
        });
      }
    }

    if (this.item?.assetMaintenanceId != null) {
      this.assetMntDocumentService.getAssetMntPermissions(this.item?.assetMaintenanceId).subscribe(permissions => this.assetMntDocumentPermission = <AssetMaintenanceDocumentPermission[]>permissions);
    }
  }


  // Asset MTN documents

  openAssetMntDocumentDialog() {
    var showActions = [];
    var modesAvailable: AssetMaintenanceRowsComponentMode[] = [];
    if (this.userDetails.hasAnyAuthority('READ_ASSET_MNT_DOCUMENT')) {
      showActions.push('download');
      modesAvailable.push('LIST_DOCUMENTS');
    }
    if (this.userDetails.hasAnyAuthority('UPLOAD_ASSET_MNT_DOCUMENT')) {
      showActions.push('delete');
      modesAvailable.push('UPLOAD_DOCUMENTS');
    }
    const dialogConfig: AssetMaintenanceDocumentEditDialogConfig<number> = {
      dialogTitle: "Asset Maintenance Documents",
      showActions: showActions,
      modesAvailable: modesAvailable,
      permissions: this.assetMntDocumentPermission,
      assetMaintenance: this.item,
      config: {
        rowsItemComponentType: AssetMaintenanceDocumentRowsComponent,
        rowsType: REPOSITORY_FILE_ROWS_TYPE,
        readOnly: true
      },
      supportsAdd: false,
      supportsSave: false,
      rows: [],
    };

    const dialogRef = openCrudRowsEditorDialogInAttributeEditorMode(this.dialog, {
      panelClass: ['contract-document-dialog', 'dialog-resizable'],
      height: '80vh',
      minWidth: '60vw',
      //minHeight: '70vh',
      data: dialogConfig
    }, AssetMaintenanceDocumentEditDialogComponent);
  }

  isAssetMntDocumentsAvailable() {
    return this.userDetails.hasAnyAuthority('READ_ASSET_MNT_DOCUMENT');
  }

  isAssetMntDocumentsEnabled() {
    return this.assetMntDocumentPermission?.length > 0;
  }

  backRouteFallback(): any[] {
    if (this.item != null) {
      return [...ASSET_MAINTENANCE_TYPE.searchRouteBase, this.item.assetId];
    } else {
      return ['/assets']
    }
  }

  editRoute(item: AssetMaintenance): any[] {
    return [...ASSET_MAINTENANCE_TYPE.editRouteBase, item.assetMaintenanceId, this.composedAssetClassParameter];
  }

  viewRoute(item: AssetMaintenance): any[] {
    return [...ASSET_MAINTENANCE_TYPE.viewRouteBase, item.assetMaintenanceId, this.composedAssetClassParameter];
  }

  get composedAssetClassParameter() {
    return this.getCombinedParams()?.composedAssetClass;
  }
}






